export default __webpack_public_path__ + "resources/icons/d441-c5c1.webp";